module.exports = __webpack_public_path__ + "img/specular.a51a50f2.jpg";